<nz-card [nzTitle]="title" [nzBodyStyle]="h1Styles" [nzExtra]="extraTemplate">
  <div *ngIf="title == 'In Progress'"><ng-lottie [options]="workInProgress" ></ng-lottie></div>
  <div *ngIf="title == 'Completed'"><ng-lottie [options]="completed" ></ng-lottie></div>
  <div *ngIf="title == 'Action Required'"><ng-lottie [options]="attention" ></ng-lottie></div>
</nz-card>
<ng-template #extraTemplate>
  <a><span nz-icon nzType="double-right" nzTheme="outline"></span></a>
</ng-template>
